import React from 'react'
import Myheader from "../../aboutus/aboutusheader/AboutHeader"

const header = () => {
    return (
        <div>
            <Myheader />
        </div>
    )
}

export default header
